import { CASH_MOVEMENT_TYPES, CASH_MOVEMENT_LABELS, CASH_SESSION_STATUS, type CashMovementType, type CashSessionStatus } from '@tumin/domain'
import type { StatusTone } from '@/components/status-badge'

/** Arqueo exacto: sin diferencia entre lo contado y lo esperado. */
export const NO_DIFFERENCE = 0
/** Prefijo del nombre de archivo del reporte de cierre. */
export const CLOSING_FILE_PREFIX = 'cierre-caja'

/** Etiquetas en español de los estados de una caja. */
export const CASH_SESSION_STATUS_LABELS: Record<CashSessionStatus, string> = {
  open: 'Abierta',
  closed: 'Cerrada',
}
/** Tono de la insignia de cada estado de caja. */
export const CASH_SESSION_STATUS_TONES: Record<CashSessionStatus, StatusTone> = {
  [CASH_SESSION_STATUS.open]: 'success',
  [CASH_SESSION_STATUS.closed]: 'neutral',
}

/** Opciones del tipo de movimiento de caja (etiquetas del dominio). */
export const CASH_MOVEMENT_OPTIONS = CASH_MOVEMENT_TYPES.map((value) => ({ value, label: CASH_MOVEMENT_LABELS[value] }))

/** Movimientos que entran a la gaveta; el resto sale de ella. */
export const CASH_MOVEMENT_ADDS: Record<CashMovementType, boolean> = {
  fund_in: true,
  fund_out: false,
  deposit_to_bank: false,
  expense: false,
}

/** Pestañas de la pantalla de caja. */
export const CASH_TABS = ['mine', 'branch'] as const
/** Pestaña de la pantalla de caja. */
export type CashTab = (typeof CASH_TABS)[number]
